/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { TagService } from "../services/tag.service";
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { PAGING_ITEMS_PER_PAGE } from "../app-constants";
import { PagedResults } from "app/models/paged-results";
import { TagInstance } from "app/models/tag-instance";

@Injectable()
export class TagInstancesPagingResolver implements Resolve<PagedResults<TagInstance>> {

  constructor(
    private tagService: TagService
  ) { }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<TagInstance>> {
    // Get the number of Tags to load from the data passed in the route (if it exists)
    let numberOfTags: number = route.data['tagsPerPage']
    if (numberOfTags == null || numberOfTags < 1) {
      // If nothing was passed or an invalid value found, revert to the default
      numberOfTags = PAGING_ITEMS_PER_PAGE;
    }
    
    try {
      return await this.tagService.getAllTagInstancesForPaging(0, numberOfTags, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Tag Instances... Error: " + error, error);
    }
  }

}
